// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__dTBSE","title":"InfoRow_title__1UCuL"};